export const ACTIVE_PSEUDONYM = 'active_pseudonym'
export const ADD_A_TREE = 'add-a-tree'
export const ALL_ENABLE_TREE_CODES = 'all-enabled-tree-codes'
export const APP_USER = 'app-user'
export const AUTH_APPROVE_USER_ACCOUNT = 'auth/approve-user-account'
export const AUTH_AUTHORIZE_USER = 'auth/authorize-user'
export const AUTH_LOGIN = 'auth/login'
export const AUTH_VERIFY = 'auth/is-verify'
export const AUTH_VERIFY_USER = 'auth/verify-user'
export const AUTH_RESET_PASSWORD = 'auth/reset-password'
export const AUTH_SEND_EMAIL_RESET_PASSWORD = 'auth/send-email-reset-password'
export const CATEGORY = 'category'
export const CATEGORY_TYPE = 'category-type'
export const CHANGE_PASSWORD = 'change-password'
export const CONTACT = 'contact'
export const CREATE_FEATURE = 'create-feature'
export const DELETE_PSEUDONYM = 'delete_pseudonym'
export const DISABLE_INCONVENIENCE = 'disable-inconvenience'
export const FAMILY = 'family'
export const FAMILY_ALL = 'filter-family'
export const FEATURE = 'feature'
export const FEATURE_LOCATION = `${FEATURE}/locations`
export const FILTERS = 'filters'
export const FORGOT_PASSWORD = 'forgot-password'
export const GEOJSON_FILTERS = 'geojson-filters'
export const GEOJSON_FILTERS_ADVANCED = 'geojson-filters-advanced'
export const HOME = 'home'
export const INCONVENIENCE = 'inconvenience'
export const GENERATE_REPORT = 'generate-report'
export const INFORMATION = 'informacion'
export const LOAD_TREE = 'load-tree'
export const LOGIN = 'login'
export const MAIN = '/'
export const META_FEATURE = 'meta-feature'
export const MANAGEMENT_TREE = 'management'
export const NOT_FOUND_404 = '*'
export const PARISH = 'parish'
export const PROFILE = 'profile'
export const PROJECT = 'project'
export const PSEUDONYM = 'pseudonym'
export const PSEUDONYM_BACTH = 'register-pseudonym-batch'
export const REGISTER_FAMILY = 'register-family'
export const REGISTER_SITE = 'register-site'
export const REGISTER_SPECIE = 'register-specie'
export const REGISTER_TREE = 'register-tree'
export const REGISTER_USER = 'register-user'
export const ROLE = 'role'
export const SITE = 'site'
export const SPECIE = 'specie'
export const TABLE_RECORDS = 'table-records'
export const TREE = 'tree'
export const UPDATE_ACCOUNT = 'update-account'
export const UPDATE_DOWNLOAD_COUNTER = `${PROJECT}/update-download`
export const UPDATE_FAMILY = 'update-family'
export const UPDATE_FEATURE = 'update-feature'
export const UPDATE_INCONVENIENCE = 'update-inconvenience'
export const UPDATE_PASSWORD = 'update-password'
export const UPDATE_SPECIE = 'update-specie'
export const UPDATE_STATUS_REGISTER = 'update-status-register'
export const UPDATE_TREE = 'update-tree'
export const VALID_TREE = 'tree/is-valid'
export const VERIFIED_WITH_FAMILY = 'family-verified'
export const WORK_GROUP = 'work-group'
export const AVAILABLETREENUMBER = 'availableTreeNumber'
